import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SandboxNotice } from "@/components/Peep";
import { PayoutPanel } from "@/pages/creator/Billing";

export default function CreatorPayouts() {
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get("/creator/payouts").then((r) => setP(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="creator-payouts" className="flex flex-col gap-6">
      <div>
        <h1 className="text-3xl font-extrabold">Banking & payouts</h1>
        <p className="mt-1 text-sm text-[#a7a0af]">Connect where your earnings are paid. Real payouts stay off until PEEPING's payment provider is approved.</p>
      </div>
      <SandboxNotice />
      {p ? <PayoutPanel p={p} /> : <p className="text-sm text-[#a7a0af]">Loading…</p>}
    </div>
  );
}
